import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { apiService } from "../../services/api";

type PasswordField = 'password' | 'confirmPassword' | 'newpassword';

const ResetPassword = () => {
  const navigate = useNavigate();
  const route = all_routes;
  
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
    newpassword: false
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPasswords(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validações
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error("As senhas não coincidem");
      return;
    }

    if (passwords.newPassword.length < 6) {
      toast.error("A nova senha deve ter no mínimo 6 caracteres");
      return;
    }

    try {
      const result = await apiService.changePassword(
        passwords.currentPassword, 
        passwords.newPassword
      );

      // Sucesso na troca de senha
      toast.success(result.message || "Senha alterada com sucesso");
      
      // Redirecionar para página de sucesso ou login
      navigate(route.success);
    } catch (error: any) {
      // Tratamento de erro
      toast.error(error.message || "Erro ao alterar a senha");
    }
  };

  return (
    <div className="account-content">
      <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-04">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form className="flex-fill" onSubmit={handleSubmit}>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  className="img-fluid logo"
                  alt="Logotipo"
                />
              </div>
              <div className="mb-4">
                <h4 className="mb-2 fs-20">Redefinir Senha?</h4>
                <p>Digite a Senha Atual, Nova Senha e Confirme para continuar</p>
              </div>
              <div className="mb-3">
                <label className="col-form-label">Senha Atual</label>
                <div className="pass-group">
                  <input
                    name="currentPassword"
                    type={passwordVisibility.password ? "text" : "password"}
                    className="pass-input form-control"
                    value={passwords.currentPassword}
                    onChange={handlePasswordChange}
                    required
                  />
                  <span
                    className={`ti toggle-passwords ${
                      passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={() => togglePasswordVisibility("password")}
                  ></span>
                </div>
              </div>
              <div className="mb-3">
                <label className="col-form-label">Nova Senha</label>
                <div className="pass-group">
                  <input
                    name="newPassword"
                    type={passwordVisibility.newpassword ? "text" : "password"}
                    className="pass-input-new form-control"
                    value={passwords.newPassword}
                    onChange={handlePasswordChange}
                    required
                  />
                  <span
                    className={`ti toggle-passwords ${
                      passwordVisibility.newpassword ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={() => togglePasswordVisibility("newpassword")}
                  ></span>
                </div>
              </div>
              <div className="mb-3">
                <label className="col-form-label">Confirmar Nova Senha</label>
                <div className="pass-group">
                  <input
                    name="confirmPassword"
                    type={passwordVisibility.confirmPassword ? "text" : "password"}
                    className="pass-input form-control"
                    value={passwords.confirmPassword}
                    onChange={handlePasswordChange}
                    required
                  />
                  <span
                    className={`ti toggle-passwords ${
                      passwordVisibility.confirmPassword ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  ></span>
                </div>
              </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-primary w-100">
                  Alterar Senha
                </button>
              </div>
              <div className="mb-3 text-center">
                <h6>
                  Voltar para{" "}
                  <Link to={route.login} className="text-purple link-hover">
                    Login
                  </Link>
                </h6>
              </div>
              <div className="text-center">
                <p className="fw-medium text-gray">Copyright © 2024 - Webbex Digital</p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;